import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserSession } from './sessions.state';

export const UserSessionActions = createActionGroup({
  source: 'User Session',
  events: {
    'Load All': emptyProps(),
    'Load Initial Success': props<{ sessions: UserSession[] }>(),
    'Add One': props<{ session: UserSession }>(),
    'Upsert One': props<{ session: UserSession }>(),
    'Upsert Many': props<{ sessions: UserSession[] }>(),
    'Remove One': props<{ session: UserSession }>(),
  },
});
